module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"false":"No","female":"Female","male":"Male","true":"Yes"}}')
  delete Component.options._Ctor
}
